import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=6a1b3f3c&scoped=true"
var script = {}
import style0 from "./BaseDivider.vue?vue&type=style&index=0&id=6a1b3f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b3f3c",
  null
  
)

export default component.exports